var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showAdminRatings)?_c('AllRatingsAdmin'):_c('AllRatingsArtist')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }